import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import makeIsSubNotPaidSelector from 'app/selectors/subs/isSubNotPaid';
import { subPay as subPayAction } from 'app/actions/apps/subs/pay';
import nope from 'app/common/lib/nope';


// type Props = {
//   subId?: string | number,
// };

const subPaymentWPay = compose(
  withTranslation('subs'),

  connect(
    () => {
      const isSubNotPaid = makeIsSubNotPaidSelector();
      return (state, props) => ({
        notPaid: isSubNotPaid(state, props),
      });
    },
    (dispatch, props) => ({
      handlePay: (e) => {
        if (e) e.preventDefault();
        return (props.subId ? dispatch(subPayAction(props.subId, 'all')) : nope());
      },
    })
  )
);

export default subPaymentWPay;
